import { render, staticRenderFns } from "./ViewDealType.vue?vue&type=template&id=3fe97387"
import script from "./ViewDealType.vue?vue&type=script&lang=js"
export * from "./ViewDealType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports